import React from 'react'
import { SecondaryLightBtn } from '../components'

const SurveyYourWay = () => {
  return (
    <div className='page'>
      <h1>Survey Your Way</h1>
      <p className='page__desc'>iKON is an innovative app designed to collect essential climate-risk data from farmers across the globe. By employing gamification and behavioral design, iKON motivates farmers to provide precise historical climate data. The app enhances data gathering by comparing data across different years and rewarding accuracy, which helps compile a detailed climate history based on collective insights.</p>
      <p className='page__desc'>Accessible through WhatsApp, iKON connects seamlessly with any farmer owning a smartphone. This easy access allows iKON to collect vital data efficiently, contributing significantly to improving tools for climate risk management, such as index insurance.</p>
      <SecondaryLightBtn>Senegal SUW →</SecondaryLightBtn>
    </div>
  )
}

export default SurveyYourWay
